module.exports = __webpack_public_path__ + "static/media/Pic-0045.3cd4963e.jpg";